var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 254,
    height: 226,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M0 0L0 226L254 226L254 0L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8bbbe",
      stroke: "none"
    },
    d: "M109 32L109 33L134 33L109 32M190 32L190 33L227 35L215.861 60L212.708 70.5664L222 73L249 73C245.957 80.4163 240.708 100.202 232.895 103.397C222.281 107.736 206.335 99.1429 196.39 105.318C192.61 107.665 190.594 114.112 188.861 118C184.023 128.856 177.03 140.205 175 152L176 152L190.51 119L197.39 107.028L233.867 105.566L240.164 97L251 71L213 70C218.979 59.7198 227.808 44.8812 229 33L190 32M49 64L50 64C57.0243 50.2221 62.7757 36.3308 80 34C64.2798 27.8789 52.9428 53.1325 49 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M76 34L76 36L106 35C97.9979 31.1557 84.7193 33.2715 76 34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8bbbe",
      stroke: "none"
    },
    d: "M81 33L81 34L87 34L81 33M91 33L91 34L97 34L91 33M101 33L101 34L107 34L101 33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M107 33L107 34L136 35C129.63 30.1739 114.846 33 107 33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8bbbe",
      stroke: "none"
    },
    d: "M135 33L135 38L136 38L135 33M187 33L181 47L182 47L189 33L187 33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M187 36L193 34C191.336 43.6338 185.352 53.1784 181.233 62C179.762 65.1501 178.307 70.2538 174.812 71.7284C161.851 77.1963 141.69 72.0015 128 72L128 73C164.159 73.7702 179.366 114.023 177 144L178 144C180.835 134.156 186.233 124.199 190.756 115C192.372 111.715 193.868 107.239 197.213 105.318C207.572 99.369 223.085 108.052 233.787 103.397C240.869 100.315 246.975 80.0829 249 73L222 72.9992L213.241 70.5664L216.309 60L227 35C218.075 35 208.897 35.6217 200 34.9066C194.888 34.4958 191.065 31.8974 187 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M89 34L90 35L89 34M106 34L106 35L134 35L133 39L134 39L135 34L106 34M185 42L186 42L192 35C188.445 45.666 183.007 59.5606 177 69C174.95 72.2215 172.402 71.3909 173 69L172 69L171 72C176.934 73.3352 178.535 68.7651 180.767 64C185.095 54.7603 191.973 44.238 193 34C188.133 34.7692 186.363 37.427 185 42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M72 35L70 36L70 37L72 35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M65 41L69 39C60.304 48.0935 56.0304 59.6922 50.9059 71C37.3935 100.816 18.1986 131.665 36.8758 164C40.6809 170.588 46.0036 177.737 53 181L53 182L47 179C52.4268 186.027 63.1065 191.553 72 190C73.2617 195.888 96.306 193 102 193L102 192C77.3127 183.131 59.4167 165.894 56 139L55 139C55.1631 158.443 67.5329 172.596 81 185C59.4558 172.606 46.5283 146.748 51.5139 122C54.4772 107.291 62.7057 93.5466 68.9198 80C76.2014 64.1261 81.3886 47.5054 96 37C82.422 52.8838 75.1552 73.0603 66.4599 92C61.2816 103.279 55.0365 114.297 55 127L56 127C58.9294 103.941 73.0476 81.8318 82.767 61C87.6979 50.4314 92.3535 40.3295 104 36C94.2174 32.8761 72.073 32.8742 65 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#193047",
      stroke: "none"
    },
    d: "M119 73L134 35C122.542 35 106.948 32.114 97.0008 38.8503C84.915 47.0348 79.1714 67.1063 73.5154 80C66.4812 96.0357 57.0757 111.223 55.1736 129C52.0855 157.862 75.5371 188.026 104 192.741C113.368 194.292 124.24 193.561 133.039 190.449C155.407 182.537 172.644 165.18 176.674 141C182.534 105.842 153.999 73.0038 119 73M172 71C181.188 69.4814 189.879 43.4892 192 35C182.623 37.9323 175.648 62.2379 172 71M69 187C66.222 182.421 60.7971 179.831 57.0401 175.985C50.0271 168.806 44.469 159.623 41.5702 150C32.8254 120.971 50.8326 93.3266 62.9861 68C68.5514 56.4026 72.1797 43.8371 84 37C78.9899 36.0077 74.3335 40.4872 71.1883 44.0147C63.3396 52.8175 59.4422 66.4162 54.4491 77C39.2035 109.316 22.3635 144.712 52.0147 174.999C56.9382 180.028 62.3677 184.49 69 187M93.6667 36.3333L94.3333 36.6667L93.6667 36.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M68 37L69 38L68 37M75 37L76 38L75 37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M69 185L69 184C47.9898 170.858 36.4859 145.341 41.5147 121C44.1869 108.066 51.3868 95.8719 56.9167 84C64.9976 66.6511 72.0674 51.8011 84 37C70.2585 42.3273 65.3279 61.7614 59.5509 74C44.8601 105.123 27.9655 136.919 50.5903 169C55.3767 175.787 61.0922 182.002 69 185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M71 185C62.5682 173.975 52.2694 166.821 47.5193 153C33.9409 113.492 67.6594 69.2184 86 37C71.8846 42.9765 66.9902 61.1164 61.0802 74C46.6412 105.477 27.7366 139.338 53.4676 171C58.1125 176.715 63.897 182.644 71 185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#193047",
      stroke: "none"
    },
    d: "M79 187C76.2204 182.417 70.7831 179.738 67.0008 175.907C60.5219 169.344 55.2182 160.766 52.358 152C42.8551 122.873 59.5932 96.653 71.7022 71C77.2759 59.192 81.412 46.304 92 38C87.3471 36.9305 83.1108 41.5758 80.3904 45.0039C73.0385 54.2684 68.3728 68.1802 63.6343 79C49.6107 111.021 32.4877 145.05 62.0147 174.996C66.8854 179.936 72.4679 184.524 79 187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M95 37C82.3649 46.0854 78.0628 59.3172 71.7052 73C56.9944 104.661 38.2096 138.929 63.5177 171C67.9994 176.679 74.2071 182.373 81 185C75.0624 177.236 67.1649 171.833 62.3133 163C45.3395 132.097 61.4339 102.456 75.2577 74C79.4281 65.4152 82.6807 56.158 87.6744 48C89.6864 44.713 95.1019 40.784 95 37M134 37L133 40L134 37M186 37L187 38L186 37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#193047",
      stroke: "none"
    },
    d: "M69.6667 38.3333L70.3333 38.6667L69.6667 38.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M58 183C49.5933 171.066 39.5863 162.859 35.7608 148C30.209 126.436 39.2401 108.086 48 89C56.1911 71.1536 63.8152 54.0694 75 38C61.6102 42.5524 56.1641 62.2592 50.7701 74C36.7824 104.446 17.9793 137.785 41.8441 169C46.137 174.615 51.3143 180.41 58 183M65 39L66 40L65 39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#193047",
      stroke: "none"
    },
    d: "M53 182L53 181C13.4736 153.157 32.959 109.251 49.49 75C55.6051 62.3298 61.0614 50.6118 69 39C56.946 43.6829 53.0601 60.3518 47.7531 71C33.9217 98.752 16.9491 129.14 31.784 160C35.9789 168.727 43.1533 179.439 53 182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M80 45L86 39L80 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8bbbe",
      stroke: "none"
    },
    d: "M134 39L129 51L130 51L134 39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M185 39L186 40L185 39M64 40L65 41L64 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M132 40L131 43L132 40M63 41L64 42L63 41M62 42L63 43L62 42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M132 42L133 43L132 42M184 42L183 44L184 42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M61 43L62 44L61 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M131 43L132 44L131 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M184 43L185 44L184 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M60 44L58 47L60 44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M130 44L129 47L130 44M183.333 44.6667L183.667 45.3333L183.333 44.6667M60 45L61 46L60 45M79 45L80 46L79 45M59 46L60 47L59 46M68 46L67 49L68 46M78 46L75 54L76 54L78 46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M130 46L131 47L130 46M182 46L181 49L182 49L182 46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M58 47L53 59L54 59L58 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M129.333 47.6667L129.667 48.3333L129.333 47.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M182.333 47.6667L182.667 48.3333L182.333 47.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M57 48L58 49L57 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M128 48L125 56L126 56L128 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8bbbe",
      stroke: "none"
    },
    d: "M180 48L175 60L176 60L180 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M66 49L65 53L66 53L66 49M181 49L179 55L180 55L181 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M56 50L57 51L56 50M128 50L127 53L128 50M180 50L181 51L180 50M55 52L56 53L55 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8bbbe",
      stroke: "none"
    },
    d: "M128 52L129 53L128 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M179 52L180 53L179 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M64 53L63 57L64 57L64 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8bbbe",
      stroke: "none"
    },
    d: "M127 53L121 68L122 68L127 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M54 54L55 55L54 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M74 54L73 58L74 58L74 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M126 55L127 56L126 55M178 55L177 57L178 55M53 56L54 57L53 56M125 56L126 57L125 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M178 56L179 57L178 56M62 57L61 62L62 62L62 57M124 57L119 69L120 69L124 57M177 57L173 68L174 68L177 57M72 58L67 71L68 71L72 58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M52 59L51 61L52 59M124 59L125 60L124 59M176 59L177 60L176 59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M52 60L53 61L52 60z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M175.333 60.6667L175.667 61.3333L175.333 60.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M51 61L47 72L48 72L51 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M123 61L124 62L123 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8bbbe",
      stroke: "none"
    },
    d: "M174 61L170 71L171 71L174 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M60 62L55 75L56 75L60 62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M50 63L51 64L50 63M122 63L123 64L122 63M174 63L175 64L174 63M49.3333 64.6667L49.6667 65.3333L49.3333 64.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8bbbe",
      stroke: "none"
    },
    d: "M48 65L43 77L44 77L48 65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M121 65L122 66L121 65M173 65L174 66L173 65M48 67L49 68L48 67M120 68L119 71L127 72L127 71L120 71L120 68M172 68L173 69L172 68M47 69L48 70L47 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8bbbe",
      stroke: "none"
    },
    d: "M120 69L123 71L123 70L120 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M171 69L172 70L171 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M66 71L65 75L66 75L66 71M119 71L128 73L128 72L119 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8bbbe",
      stroke: "none"
    },
    d: "M127 71L127 72L170 72C158.774 67.2896 139.219 71 127 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M46 72L45 74L46 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M46 73L47 74L46 73M129 73L129 74L143 77L129 73M45.3333 74.6667L45.6667 75.3333L45.3333 74.6667M54 75L53 79L54 79L54 75M64 75L63 79L64 79L64 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M44 76L43 78L44 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M44 77L45 78L44 77M143 77L143 78L151 82L143 77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8bbbe",
      stroke: "none"
    },
    d: "M42 78L35 94L36 94L42 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M43 78L39 89L40 89L43 78M52 79L51 83L52 83L52 79M62 79L61 84L62 84L62 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M42 80L43 81L42 80M41 82L42 83L41 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M151 82L151 83L160 89L151 82M50 83L49 88L50 88L50 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M40 84L41 85L40 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M60 84L59 88L60 88L60 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M39 86L40 87L39 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M48 88L47 92L48 92L48 88M58 88L55 97L56 97L58 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M38 89L37 91L38 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M160 89L161 90L160 89M38 90L39 91L38 90M161 90L165 95L161 90M37 91L35 98L36 98L37 91M46 92L41 105L42 105L46 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M36 93L37 94L36 93M35.3333 94.6667L35.6667 95.3333L35.3333 94.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8bbbe",
      stroke: "none"
    },
    d: "M34 95C26.6195 112.751 24 125.788 24 145L25 145L26.885 116L34 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M165 95L167 98L165 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M34 97L33 100L34 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M54 97L53 101L54 101L54 97M167 98L169 101L167 98M34 99L35 100L34 99M33.3333 100.667L33.6667 101.333L33.3333 100.667M52 101L51 105L52 105L52 101M169 101L172 109L173 109L169 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M32 102L31 104L32 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M32 103L33 104L32 103M31 104C26.3606 120.962 22.0252 135.493 28 153L29 153C26.5073 143.39 24.5008 132.962 26.375 123C27.4541 117.264 32.5541 109.604 31 104M40 105L39 110L40 110L40 105M50 105L49 110L50 110L50 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M30 106L31 107L30 106M29 108L30 109L29 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M173 109L174 115L175 115L173 109M38 110L37 115L38 115L38 110M48 110L47 116L48 116L48 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M28 111L29 112L28 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M107 114L107 115C119.739 111.63 129.92 114.224 136 127C138.345 112.567 115.933 110.744 107 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M27 113L28 114L27 113M111.667 113.333L112.333 113.667L111.667 113.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8bbbe",
      stroke: "none"
    },
    d: "M133 144C129.091 146.661 125.675 149.805 121 151.071C86.8181 160.329 97.5867 97.0504 126.996 117.652C130.137 119.853 132.263 122.655 134 126C136.262 109.019 106.57 111.61 100.225 122.015C86.9806 143.732 118.019 164.767 133 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M121.667 113.333L122.333 113.667L121.667 113.333M109 114L110 115L109 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M113 114.519C88.9508 119.659 97.1083 156.804 121 151.319C144.749 145.868 136.636 109.467 113 114.519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M124 114L125 115L124 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M36 115L35 124L36 124L36 115M105 115L104 117L105 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M106 115L107 116L106 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M175 115L176 123L177 123L175 115M46 116L45 125L46 125L46 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M105 116L106 117L105 116M26.3333 117.667L26.6667 118.333L26.3333 117.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M103 117L104 118L103 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M129 117L130 118L129 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M102 118L103 119L102 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M130 118L131 119L130 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M101 119L102 120L101 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M131 119L132 120L131 119M25 120L26 121L25 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M100 120L99 122L100 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M132 120L133 121L132 120M100 121L101 122L100 121M99 122L100 123L99 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M98 123C95.2118 130.65 94.5177 140.074 101 146L98 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M134 123L135 124L134 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M177 124L177 140L178 140L177 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M98 125L99 126L98 125M135 125L136 129L137 129L135 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M34 126L34 140L35 140L34 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M97.3333 127.667L97.6667 128.333L97.3333 127.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8bbbe",
      stroke: "none"
    },
    d: "M135 127L135 139L136 139L135 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M137 128L137 138L138 138L137 128M44 130L44 136L45 136L44 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M136 137L135 140L136 137M97 138L98 139L97 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M136 139L137 140L136 139M45 140L46 150L47 150L45 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M98 140L99 141L98 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8bbbe",
      stroke: "none"
    },
    d: "M134 140L133 143L134 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M135 140C130.081 152.688 118.554 154.057 107 151L107 152C115.052 154.935 138.202 153.928 135 140M35 142L36 151L37 151L35 142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M134 142L135 143L134 142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M176 142L173 153L174 153L176 142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M99 143L100 144L99 143M133 143L134 144L133 143M25.3333 144.667L25.6667 145.333L25.3333 144.667M100 144L101 145L100 144M132 145L133 146L132 145M176.333 145.667L176.667 146.333L176.333 145.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8bbbe",
      stroke: "none"
    },
    d: "M25 146L26 152L27 152L25 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M101 146L102 147L101 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M131 146L132 147L131 146M26.3333 147.667L26.6667 148.333L26.3333 147.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M102 147L103 148L102 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M130 147L131 148L130 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M103 148L104 149L103 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M129 148L130 149L129 148M175 148L176 149L175 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M104 149L106 151L104 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M105 149L106 150L105 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M47 150L50 160L51 160L47 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M106 150L107 151L106 150M126 150L127 151L126 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M37 151L38 156L39 156L37 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M109 151L110 152L109 151M124 151L125 152L124 151M174 151L173 155L174 155L174 151M27 152L28 155L29 155L27 152M111.667 152.333L112.333 152.667L111.667 152.333M121.667 152.333L122.333 152.667L121.667 152.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8bbbe",
      stroke: "none"
    },
    d: "M27.3333 153.667L27.6667 154.333L27.3333 153.667M174.333 153.667L174.667 154.333L174.333 153.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M29 154L32 162L33 162L29 154M172 154L167 165L168 165L172 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8bbbe",
      stroke: "none"
    },
    d: "M28 155L35 168L28 155M173.333 155.667L173.667 156.333L173.333 155.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M39 156L40 161L41 161L39 156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M172 156L171 159L172 156M29 157L30 158L29 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8bbbe",
      stroke: "none"
    },
    d: "M172 158L173 159L172 158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M30 159L31 160L30 159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8bbbe",
      stroke: "none"
    },
    d: "M171 159C164.76 175.463 148.02 186.58 132 192L132 193C144.601 190.014 157.017 182.315 164.869 171.999C167.593 168.421 172.099 163.702 171 159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M51 160L52 164L53 164L51 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M31 161L32 162L31 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M41 161L43 164L41 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M170 161L171 162L170 161M32 162L33 163L32 162M169 162L170 163L169 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M33 163L39 171L33 163M43 164L47 170L43 164M53 164L57 170L53 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M168 164L169 165L168 164M33 165L34 166L33 165M167 165L168 166L167 165M34 166L35 167L34 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M166 166L161 173L166 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M166 167L167 168L166 167M35 168L39 172L35 168M165 168L166 169L165 168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8bbbe",
      stroke: "none"
    },
    d: "M35 169L36 170L35 169M36 170L37 171L36 170z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M57 170L58 171L57 170z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M164 170L165 171L164 170z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8bbbe",
      stroke: "none"
    },
    d: "M37 171C42.3513 182.474 58.0536 190.501 70 193L70 192C56.2023 187.206 48.5873 179.162 37 171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M58 171L68 181L58 171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M163 171L164 172L163 171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M39 172L40 173L39 172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M162 172L163 173L162 172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M40 173L41 174L40 173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M161 173L162 174L161 173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M41 174L42 175L41 174M160 174L161 175L160 174M42 175L43 176L42 175M159 175L160 176L159 175M43 176L44 177L43 176M158 176L159 177L158 176M44 177L45 178L44 177M156 177L153 181L156 177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M157 177L158 178L157 177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M45 178L46 179L45 178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M156 178L157 179L156 178M46 179L47 180L46 179M155 179L156 180L155 179M47 180L48 181L47 180M154 180L155 181L154 180M48 181L49 182L48 181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M150 183L153 182L150 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M49 182L50 183L49 182M151 182L152 183L151 182M51 183L52 184L51 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#193047",
      stroke: "none"
    },
    d: "M54 183L56 185L54 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M58 183L61 185L58 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456470",
      stroke: "none"
    },
    d: "M148 183L129 193L149 184L148 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M149 183L150 184L149 183M52 184L53 185L52 184M148 184L149 185L148 184M54 185L55 186L54 185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#193047",
      stroke: "none"
    },
    d: "M57 185L58 186L57 185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M61.6667 185.333L62.3333 185.667L61.6667 185.333M71.6667 185.333L72.3333 185.667L71.6667 185.333M82 185L84 187L82 185M146 185L147 186L146 185M56 186L57 187L56 186M63 186L64 187L63 186M73 186L74 187L73 186M145 186L146 187L145 186M58 187L59 188L58 187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#193047",
      stroke: "none"
    },
    d: "M71 187L72 188L71 187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M75.6667 187.333L76.3333 187.667L75.6667 187.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#193047",
      stroke: "none"
    },
    d: "M80 187L83 189L80 187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M143 187L144 188L143 187M60 188L61 189L60 188M66 188L67 189L66 188M141 188L142 189L141 188M62.6667 189.333L63.3333 189.667L62.6667 189.333M138 189L139 190L138 189M64 190L65 191L64 190M69 190L72 193L69 190z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#193047",
      stroke: "none"
    },
    d: "M75.6667 190.333L76.3333 190.667L75.6667 190.333M86 190L87 191L86 190z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9891",
      stroke: "none"
    },
    d: "M136 190L137 191L136 190M132.667 191.333L133.333 191.667L132.667 191.333M131 192L132 193L131 192z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7dfce7cc60bdf3e7434037bcac474abe.svg";
export { ForwardRef as ReactComponent };